export default "__VITE_ASSET__5JCq9OQi__"